import React from 'react';

export interface GoogleColorIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const GoogleColorIcon: React.FC<GoogleColorIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <g filter="url(#a)"><path fill="currentColor" d="M15.895 8.921c-3.095 0-5.72 2.066-6.64 4.929l-.058-.02-3.977-3.145C7.155 6.725 11.192 4 15.859 4a11.74 11.74 0 0 1 7.809 2.966L20.23 10.47a6.84 6.84 0 0 0-4.336-1.549"/><path fill="currentColor" d="M21.076 20.99a7.3 7.3 0 0 0 1.111-2.476h-6.285v-4.681h11.015a12.1 12.1 0 0 1-.278 6.21 12 12 0 0 1-1.47 3.112 12 12 0 0 1-1.631 1.906l-.05-.053-3.721-2.931a7 7 0 0 0 1.269-1.115z"/><path fill="currentColor" d="M9.197 18.157c.862 2.962 3.534 5.121 6.698 5.121a6.83 6.83 0 0 0 3.872-1.201l3.72 2.93.05.054a12.4 12.4 0 0 1-1.783 1.41l-.04-.062a11.7 11.7 0 0 1-5.855 1.56c-4.667 0-8.704-2.725-10.64-6.686z"/><path fill="currentColor" d="m9.197 13.83.059.02a7.4 7.4 0 0 0-.35 2.25c0 .714.102 1.405.291 2.057L5.22 21.283A12.04 12.04 0 0 1 4 15.985c0-1.903.439-3.702 1.22-5.3z"/></g><defs><filter id="a" width="32" height="32" x="-.402" y="-.015" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"/><feBlend in2="BackgroundImageFix" mode="overlay" result="effect1_dropShadow_194_205101"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="1"/><feGaussianBlur stdDeviation=".5"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/><feBlend in2="effect1_dropShadow_194_205101" mode="multiply" result="effect2_dropShadow_194_205101"/><feBlend in="SourceGraphic" in2="effect2_dropShadow_194_205101" result="shape"/></filter></defs>
    </svg>
  );
};

export default GoogleColorIcon;
